import { MultiPickType } from "blackbox";
import { COLOR } from "../../../shared/shared";
import { ModelRect } from "../utilities/types";
import { getLabelRectData } from "../utilities/helpers";

/**
 * The LabelRect component is a rectangle that represents a label on a box.
 * 
 * @param props The parent box and the number of labels to be displayed (for multipick case)
 * @returns An SVG rectangle representing the label
 */
export const LabelRect = (props: {
  box: ModelRect,
  multipickLabelNumber?: number
}) => {
  // multipick box calculations
  const numBoxes = (props.box.multipick ?? 0) + 1;
  const isWidthGreater = props.box.width > props.box.height;
  const boxWidth = isWidthGreater ? props.box.width / numBoxes : props.box.width;
  const boxHeight = isWidthGreater ? props.box.height : props.box.height / numBoxes;
  const multipickOffset = 
    props.box.multipick !== undefined && props.box.multipick !== MultiPickType.None && props.multipickLabelNumber !== undefined
      ? (
          isWidthGreater
            ? boxWidth
            : boxHeight
        ) * props.multipickLabelNumber
      : 0;

  const maxBoxDim = Math.max(boxWidth, boxHeight);
  const minBoxDim = Math.min(boxWidth, boxHeight);

  const labelProps = getLabelRectData(
    props.box,
    /**
     * These are the label rectangle properties
     * if the label is placed in the top left corner of the box
     */
    {
      x: maxBoxDim / 15 + (isWidthGreater ? multipickOffset : 0),
      y: maxBoxDim / 15 + (isWidthGreater ? 0 : multipickOffset),
      width: maxBoxDim / 5,
      height: minBoxDim / 15
    }
  );

  return (
    <rect 
      fill={COLOR.BLACK}
      {...labelProps}
    />
  )
}
